/*
 *
 * ActivityReviewPage actions
 *
 */

const SCOPE = 'app/ActivityReviewPage/';
export const ActionTypes = {
    RESET_CONTENTS: `${SCOPE}RESET_CONTENTS`,
    SET_PARAMS: `${SCOPE}SET_PARAMS`,
    SET_IS_404: `${SCOPE}SET_IS_404`,

    SET_PAGE_IS_LOADED: `${SCOPE}SET_PAGE_IS_LOADED`,
    FETCH_PAGE: `${SCOPE}FETCH_PAGE`,
    FETCH_PAGE_STARTED: `${SCOPE}FETCH_PAGE_STARTED`,
    FETCH_PAGE_SUCCESSFULLY: `${SCOPE}FETCH_PAGE_SUCCESSFULLY`,
    FETCH_PAGE_FAILED: `${SCOPE}FETCH_PAGE_FAILED`,
    FETCH_PAGE_CANCELLED: `${SCOPE}FETCH_PAGE_CANCELLED`,

    SET_REVIEW_IS_LOADED: `${SCOPE}SET_REVIEW_IS_LOADED`,
    FETCH_REVIEW: `${SCOPE}FETCH_REVIEW`,
    RESET_REVIEW: `${SCOPE}RESET_REVIEW`,
    FETCH_REVIEW_STARTED: `${SCOPE}FETCH_REVIEW_STARTED`,
    FETCH_REVIEW_SUCCESSFULLY: `${SCOPE}FETCH_REVIEW_SUCCESSFULLY`,
    FETCH_REVIEW_FAILED: `${SCOPE}FETCH_REVIEW_FAILED`,
    FETCH_REVIEW_CANCELLED: `${SCOPE}FETCH_REVIEW_CANCELLED`,
};

/**
 * Common
 */
export const setIs404 = (is404) => ({
    type: ActionTypes.SET_IS_404,
    is404,
});

export const setParams = (params) => ({
    type: ActionTypes.SET_PARAMS,
    params,
});

export const resetContents = () => ({ type: ActionTypes.RESET_CONTENTS });

/**
 * Page
 */
export const setPageIsLoaded = (isLoaded) => ({ type: ActionTypes.SET_PAGE_IS_LOADED, isLoaded });
export const fetchPage = () => ({ type: ActionTypes.FETCH_PAGE });
export const fetchPageStarted = () => ({ type: ActionTypes.FETCH_PAGE_STARTED });
export const fetchPageSuccessfully = (res) => ({
    type: ActionTypes.FETCH_PAGE_SUCCESSFULLY,
    res,
});
export const fetchPageFailed = (error) => ({
    type: ActionTypes.FETCH_PAGE_FAILED,
    error,
});
export const fetchPageCancelled = () => ({
    type: ActionTypes.FETCH_PAGE_CANCELLED,
});

/**
 * Review
 */
export const setReviewIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_REVIEW_IS_LOADED,
    isLoaded,
});
export const fetchReview = () => ({ type: ActionTypes.FETCH_REVIEW });
export const resetReview = () => ({ type: ActionTypes.RESET_REVIEW });
export const fetchReviewStarted = () => ({ type: ActionTypes.FETCH_REVIEW_STARTED });
export const fetchReviewSuccessfully = (res) => ({
    type: ActionTypes.FETCH_REVIEW_SUCCESSFULLY,
    res,
});
export const fetchReviewFailed = (error) => ({
    type: ActionTypes.FETCH_REVIEW_FAILED,
    error,
});
export const fetchReviewCancelled = () => ({
    type: ActionTypes.FETCH_REVIEW_CANCELLED,
});
